import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import VerificationOperationsFinal from "@/pages/VerificationOperationsFinal";

export default function VerificationOpsGuard() {
  const [allowed, setAllowed] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem("coi_platform_token");
    api.get("/verifications/staff/queue", { headers: { Authorization: `Bearer ${token}` } })
      .then(() => setAllowed(true))
      .catch(() => setAllowed(false));
  }, []);
  if (allowed === null) return <section className="p-6 text-sm text-slate-500">Loading verification operations…</section>;
  if (!allowed) return <section className="p-6" data-testid="verification-ops-access-denied"><p className="text-xs font-bold uppercase tracking-[.18em] text-blue-700">Platform operations</p><h1 className="mt-2 text-2xl font-semibold">Platform admin sign-in required</h1><p className="mt-3 max-w-xl text-sm leading-6 text-slate-600">Policy verification contacts are available only to authorized COIGuardian staff. Sign in through the platform admin portal to continue.</p></section>;
  return <VerificationOperationsFinal />;
}